/**
 * BriqueChart Sample 화면
 */
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  data () {
    return {
      series: 1, // 기본 시리즈 1개
      points: 100000, // 기본값 10만개
      marker: false,
      webgl: false,
      sampling: false, // 기본값은 체크 해제
      samplingCnt: 9999999999, // Sampling 여부 활성화에 쓰기 위한 cnt, 기본값은 sampling 안함
      yArr: [], // Points 바뀌지 않으면 데이터 유지하기 위한 배열
      originPoints: 0, // points 수 변경 감지를 위한 param
      originSeries: 0 // series 수 변경 감지를 위한 param
    }
  },

  methods: {
    /** 라인 차트를 그린다. */
    drawChart () {
      // let gLoadingBar = this.$store.getters.loadingBars.gLoadingBar// Store에 있는 Global 로딩바(App.vue에서 설정함)
      // gLoadingBar.show()

      let seed = 0

      // point나 series 값이 변경되면 y 배열 변경
      if (this.originPoints !== this.points || this.originSeries !== this.series) {
        this.yArr = []
      }

      let traces = new Array(this.series).fill(0).map((v, traceNumber) => {
        // Series와 Points 수가 변경되지 않으면 기존 데이터 유지함
        if (this.originPoints !== this.points || this.originSeries !== this.series) {
          this.yArr.push(new Array(this.points).fill(0).map(() => { seed += Math.random() * 10 - 5; return seed }))
        }

        return {
          x: new Array(this.points).fill(0).map((v, index) => index - 10),
          y: this.yArr[traceNumber],
          name: 'Series ' + traceNumber,
          // mode: this.marker ? 'lines+markers' : 'lines'
          type: this.webgl ? 'scattergl' : 'scatter',
          mode: 'lines'
          // type: this.webgl ? 'scattergl' : 'bar'
          // marker: {
          //   size: 200
          // }
          // line: { shape: 'spline' }

        }
      })

      // let traces = [
      //   {
      //     // x: new Array(this.points).fill(0).map((v, index) => index - 10),
      //     // y: new Array(this.points).fill(0).map(() => { seed += Math.random() * 10 - 5; return seed }),
      //     x: [1, 4, 3, 2],
      //     y: [2, 4, 6, 8],
      //     name: '긴문자열 테스트입니다_',
      //     // mode: this.marker ? 'lines+markers' : 'lines',
      //     mode: 'markers',
      //     type: this.webgl ? 'scattergl' : 'scatter'
      //     // type: this.webgl ? 'scattergl' : 'bar'
      //     // marker: {
      //     //   size: 200
      //     // }

      //   }
      // ]

      let layout = {
        title: {
          text: 'Raw Data Chart' // 202112 ChartSample 'Line Chart'
        },
        // margin: {
        //   t: 100
        // },
        coloraxis: {
          colorscale: [
            ['0', 'rgb(165,0,38)'],
            ['1000', 'rgb(165,0,38)'],
            ['1000', 'rgb(49,54,149)'],
            ['2000', 'rgb(49,54,149)']
          ]
        },
        xaxis: {
          // automargin: true,
          title: {
            text: 'X축 타이틀'
            // standoff:
          },
          tickangle: 'auto'
          // automargin: true
          // tickprefix: 'X축 Tick Prefix '
          // tickfont: {
          //   size:
          // }
          // rangeslider: {}
        },
        yaxis: {
          // automargin: true,
          title: {
            text: 'Y축 타이틀'
          }
          // tickprefix: 'Y축 Tick Prefix입니다.. 길게 입력해 봅니다. '
          // tickfont: {
          //   size:
          // }
        }
        // shapes: [
        //   { // Quadratic Bezier Curves
        //     type: 'path',
        //     path: 'M 4,4 Q 6,0 8,4',
        //     line: {
        //       color: 'rgb(93, 164, 214)'
        //     }
        //   },
        //   { // Cubic Bezier Curves
        //     type: 'path',
        //     path: 'M 3,4 C 2,8 6,4 -25,-25',
        //     line: {
        //       color: 'rgb(207, 114, 255)'
        //     }
        //   },
        //   { // Cubic Bezier Curves
        //     type: 'path',
        //     path: 'M 15,4 C 2,8 6,4 15,15',
        //     line: {
        //       color: 'rgb(207, 114, 255)'
        //     }
        //   },
        //   { // Filled Triangle
        //     type: 'path',
        //     path: 'M 1 1 L 1 3 L 4 1 Z',
        //     fillcolor: 'rgba(44, 160, 101, 0.5)',
        //     line: {
        //       color: 'rgb(44, 160, 101)'
        //     }
        //   },
        //   { // Filled Polygon
        //     type: 'path',
        //     path: ' M 3,7 L2,8 L2,9 L3,10, L4,10 L5,9 L5,8 L4,7 Z',
        //     fillcolor: 'rgba(255, 140, 184, 0.5)',
        //     line: {
        //       color: 'rgb(255, 140, 184)'
        //     }
        //   }
        // ]

      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
        // modeBarButtons: [['toImage', 'zoom2d', 'pan2d', 'zoomIn2d', 'zoomOut2d', 'resetScale2d', 'hoverClosestCartesian', 'hoverCompareCartesian', {
        //   name: 'color toggler',
        //   icon: BriqueChart.Icons.pencil,
        //   click: function (gd) {
        //     let colors = ['green', 'red', 'blue']
        //     let newColor = colors[Math.floor(3 * Math.random())]
        //     BriqueChart.restyle(gd, 'line.color', newColor)
        //   } }]]
      }

      let briquechartOption = {
        legend: {
          position: 'bottom'
        },
        xaxis: {
          rangeslider: {
            // seriesIndices: [0]
          }
        },
        data: {
          samplingData: {
            totalCountForSamplingDataOnInit: this.samplingCnt // Data Sampling 적용 여부 cnt로 조절
          }
        },
        isSampleChart: true // 202112 ChartSample
      }
      console.time('render')
      let promise = BriqueChart.newPlot('chart', traces, layout, config, briquechartOption)

      // gLoadingBar.hide() // Store에 있는 로딩바
      promise.then(() => {
        console.timeEnd('render')

        let element = document.getElementById('chart')

        this.originSeries = this.series
        this.originPoints = this.points // points 갯수 저장하기

        element.on('plotly_selected', function (data) {
          // select2d에서 mode가 lines일때는 points에 값이 들어오지 않음
          console.log('plotly_selected')
          console.log(arguments)
        })
      })
    },
    isSampling (value) {
      if (value) {
        this.samplingCnt = 0 // 0개 이상 sampling(무조건 샘플링)
      } else {
        this.samplingCnt = 99999999999 // 자동 sampling 해제
      }
    }
  }
}
